import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://swarmcitadel.com";
const IMAGE = "https://customer-assets.emergentagent.com/job_sentinel-hub-28/artifacts/wujg6877_SwarmCitadel-logo-mark.png";

export const Seo = ({ title, description, path = "/", type = "website", children }) => {
  const url = `${SITE}${path}`;
  useEffect(() => {
    document.querySelectorAll("head [data-static-seo]").forEach((el) => el.remove());
  }, []);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={IMAGE} />
      <meta property="og:site_name" content="SwarmCitadel" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={IMAGE} />
      {children}
    </Helmet>
  );
};
